export default "__VITE_ASSET__ce8116c9__"